import gql from 'graphql-tag'

export const inviteToPlatformMutation = gql`
  mutation SendConnectionInvitation($studentIds: [ID!]!) {
    SendConnectionInvitation(studentIds: $studentIds) {
      message
      success
    }
  }
`
